import {Card, Table} from 'react-bootstrap'
import {INodeIdentities, NodeOne} from '../../../../graphql/types/usersTypes'
import {BadgeStatus} from './BadgeStatus'
import moment from 'moment'
import {useState} from 'react'
import {ViewOneValidation} from './ViewOneValidation'

interface IResumenVal {
  user: NodeOne
  refetch: () => void
}

export const ResumenValidations: React.FC<IResumenVal> = ({user, refetch}) => {
  const {
    identityvalidationSet: {edges},
  } = user

  const [infoValidation, setInfoValidation] = useState<null | INodeIdentities>(null)

  const onBack = () => setInfoValidation(null)

  if (!edges || edges.length === 0) {
    return (
      <Card.Body
        className='animation animation-fade-in d-flex align-items-center justify-content-center'
        style={{height: '40vh'}}
      >
        <p className='fs-2'>No hay validaciones actualmente</p>
      </Card.Body>
    )
  }

  return (
    <div>
      {infoValidation ? (
        <ViewOneValidation refetch={refetch} info={infoValidation} onBack={onBack} />
      ) : (
        <Table responsive striped bordered hover size='sm' style={{whiteSpace: 'nowrap'}}>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>No. Identificación</th>
              <th>Teléfono</th>
              <th>Estado</th>
              <th>Creada</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {edges.map(({node}) => (
              <tr key={node.id}>
                <td>
                  {node.firstName} {node.secondName || ''} {node.firstSurname}{' '}
                  {node.secondSurname || ''}
                </td>
                <td>
                  {node.documentType} {node.documentNumber}
                </td>
                <td>{node.phoneNumber}</td>
                <td>
                  <BadgeStatus status={node.status} />
                </td>
                <td>{moment(node.created).format('DD MMM YYYY')}</td>
                <td className='text-center'>
                  <span
                    role='button'
                    className='fw-semibold text-hover-primary'
                    onClick={() => setInfoValidation(node)}
                  >
                    Ver
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  )
}
